'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { AriaLabelDictionary } from '@/lib/a11y/types';

const AriaLabelsContext = createContext<AriaLabelDictionary | null>(null);

/**
 * Provides the resolved (locale-merged) aria-label dictionary to client
 * components. Populated server-side in the locale layout so only the active
 * locale's data is serialized to the client.
 */
export function AriaLabelsProvider({
  dictionary,
  children,
}: {
  dictionary: AriaLabelDictionary;
  children: ReactNode;
}) {
  return <AriaLabelsContext.Provider value={dictionary}>{children}</AriaLabelsContext.Provider>;
}

export function useAriaDictionary(): AriaLabelDictionary {
  const dict = useContext(AriaLabelsContext);
  if (!dict) {
    throw new Error('useAriaDictionary must be used within an AriaLabelsProvider');
  }
  return dict;
}
